import { createAction } from '@reduxjs/toolkit';

export const showForm = createAction('SHOW_FORM');
export const performedModalRecompute = createAction('MODAL_RECOMPUTED');
export const triggerModalRecompute = createAction('TRIGGER_MODAL_RECOMPUTE');
